<template>
  <div class="overlay-modal-container" v-if="isOpen">
    <div class="overlay-modal-wrapper">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "OverlayModal",
  props: ['isOpen'],
  data () {
    return {
    }
  }
}
</script>

<style lang="scss" scoped>
.overlay-modal-container {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 9999;
  background-color: #024089;
  height: 100vh;
  width: 100vw;

  .overlay-modal-wrapper {
    height: 100%;
    width: 100%;
  }
}
</style>
